export enum TSEigentumsverhaeltnis {
    GRUNDEIGENTUEMER = <any> 'GRUNDEIGENTUEMER',
    GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER = <any> 'GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER',
    PAECHTER = <any> 'PAECHTER',
    VERSICHERTER = <any> 'VERSICHERTER',
    UNBEKANNT = <any> 'UNBEKANNT'
}

export function getTSEigentumsverhaeltnisValues(): Array<TSEigentumsverhaeltnis> {
    return [
        TSEigentumsverhaeltnis.GRUNDEIGENTUEMER,
        TSEigentumsverhaeltnis.GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER,
        TSEigentumsverhaeltnis.PAECHTER,
        TSEigentumsverhaeltnis.VERSICHERTER,
        TSEigentumsverhaeltnis.UNBEKANNT,
    ];
}

export function getTSEigentumsverhaeltnisValuesSchadenfall(): Array<TSEigentumsverhaeltnis> {
    return [
        TSEigentumsverhaeltnis.GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER,
        TSEigentumsverhaeltnis.PAECHTER,
        TSEigentumsverhaeltnis.GRUNDEIGENTUEMER,
    ];
}

export function eigentumsverhaeltnisPrefix(): string {
    return 'TSEigentumsverhaeltnis_';
}






// WEBPACK FOOTER //
// ./src/app/models/enums/TSEigentumsverhaeltnis.ts